// extracted by mini-css-extract-plugin
export var roundCorners = "roundCorners-module--round-corners--f35ae";